export default [
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9685,
        "Short-Term Debt": 0.0315
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9603,
        "Short-Term Debt": 0.0397
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9667,
        "Short-Term Debt": 0.0333
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9699,
        "Short-Term Debt": 0.0301
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9691,
        "Short-Term Debt": 0.0309
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.98,
        "Short-Term Debt": 0.02
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9788,
        "Short-Term Debt": 0.0212
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9788,
        "Short-Term Debt": 0.0212
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9806,
        "Short-Term Debt": 0.0194
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9788,
        "Short-Term Debt": 0.0212
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9813,
        "Short-Term Debt": 0.0187
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9839,
        "Short-Term Debt": 0.0161
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9836,
        "Short-Term Debt": 0.0164
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9816,
        "Short-Term Debt": 0.0184
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9814,
        "Short-Term Debt": 0.0186
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9797,
        "Short-Term Debt": 0.0203
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.982,
        "Short-Term Debt": 0.018
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9814,
        "Short-Term Debt": 0.0186
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9802,
        "Short-Term Debt": 0.0198
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9945,
        "Short-Term Debt": 0.0055
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.998,
        "Short-Term Debt": 0.002
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9646,
        "Short-Term Debt": 0.0354
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9765,
        "Short-Term Debt": 0.0235
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9673,
        "Short-Term Debt": 0.0327
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9786,
        "Short-Term Debt": 0.0214
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9888,
        "Short-Term Debt": 0.0112
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9842,
        "Short-Term Debt": 0.0158
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.989,
        "Short-Term Debt": 0.011
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9892,
        "Short-Term Debt": 0.0108
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9914,
        "Short-Term Debt": 0.0086
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9933,
        "Short-Term Debt": 0.0067
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9998,
        "Short-Term Debt": 0.0002
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 5.2791e-06
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 9.7057e-06
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 1.2222e-06
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 1.1727e-06
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9659,
        "Short-Term Debt": 0.0341
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.989,
        "Short-Term Debt": 0.011
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9958,
        "Short-Term Debt": 0.0042
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9706,
        "Short-Term Debt": 0.0294
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9807,
        "Short-Term Debt": 0.0193
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9907,
        "Short-Term Debt": 0.0093
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9756,
        "Short-Term Debt": 0.0244
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9883,
        "Short-Term Debt": 0.0117
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9771,
        "Short-Term Debt": 0.0229
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9789,
        "Short-Term Debt": 0.0211
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9703,
        "Short-Term Debt": 0.0297
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9792,
        "Short-Term Debt": 0.0208
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9707,
        "Short-Term Debt": 0.0293
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01"
    }, {
        "year": "2003-01-01"
    }, {
        "year": "2004-01-01"
    }, {
        "year": "2005-01-01"
    }, {
        "year": "2006-01-01"
    }, {
        "year": "2007-01-01"
    }, {
        "year": "2008-01-01"
    }, {
        "year": "2009-01-01"
    }, {
        "year": "2010-01-01"
    }, {
        "year": "2011-01-01"
    }, {
        "year": "2012-01-01"
    }, {
        "year": "2013-01-01"
    }, {
        "year": "2014-01-01"
    }, {
        "year": "2015-01-01"
    }, {
        "year": "2016-01-01"
    }, {
        "year": "2017-01-01"
    }, {
        "year": "2018-01-01"
    }, {
        "year": "2019-01-01"
    }, {
        "year": "2020-01-01"
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9183,
        "Short-Term Debt": 0.0817
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9952,
        "Short-Term Debt": 0.0048
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.886,
        "Short-Term Debt": 0.114
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9338,
        "Short-Term Debt": 0.0662
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9104,
        "Short-Term Debt": 0.0896
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9739,
        "Short-Term Debt": 0.0261
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9731,
        "Short-Term Debt": 0.0269
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9754,
        "Short-Term Debt": 0.0246
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9844,
        "Short-Term Debt": 0.0156
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9839,
        "Short-Term Debt": 0.0161
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9975,
        "Short-Term Debt": 0.0025
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9821,
        "Short-Term Debt": 0.0179
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9899,
        "Short-Term Debt": 0.0101
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9975,
        "Short-Term Debt": 0.0025
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.99,
        "Short-Term Debt": 0.01
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9977,
        "Short-Term Debt": 0.0023
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.985,
        "Short-Term Debt": 0.015
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9706,
        "Short-Term Debt": 0.0294
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9729,
        "Short-Term Debt": 0.0271
    }],
    [{
        "year": "2002-01-01"
    }, {
        "year": "2003-01-01"
    }, {
        "year": "2004-01-01"
    }, {
        "year": "2005-01-01"
    }, {
        "year": "2006-01-01"
    }, {
        "year": "2007-01-01"
    }, {
        "year": "2008-01-01"
    }, {
        "year": "2009-01-01"
    }, {
        "year": "2010-01-01"
    }, {
        "year": "2011-01-01"
    }, {
        "year": "2012-01-01"
    }, {
        "year": "2013-01-01"
    }, {
        "year": "2014-01-01"
    }, {
        "year": "2015-01-01"
    }, {
        "year": "2016-01-01"
    }, {
        "year": "2017-01-01"
    }, {
        "year": "2018-01-01"
    }, {
        "year": "2019-01-01"
    }, {
        "year": "2020-01-01"
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9846,
        "Short-Term Debt": 0.0154
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9948,
        "Short-Term Debt": 0.0052
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9862,
        "Short-Term Debt": 0.0138
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9856,
        "Short-Term Debt": 0.0144
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9887,
        "Short-Term Debt": 0.0113
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9917,
        "Short-Term Debt": 0.0083
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9995,
        "Short-Term Debt": 0.0005
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9991,
        "Short-Term Debt": 0.0009
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9997,
        "Short-Term Debt": 0.0003
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9997,
        "Short-Term Debt": 0.0003
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9995,
        "Short-Term Debt": 0.0005
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9838,
        "Short-Term Debt": 0.0162
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.977,
        "Short-Term Debt": 0.023
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9811,
        "Short-Term Debt": 0.0189
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9894,
        "Short-Term Debt": 0.0106
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9927,
        "Short-Term Debt": 0.0073
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9957,
        "Short-Term Debt": 0.0043
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9959,
        "Short-Term Debt": 0.0041
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9945,
        "Short-Term Debt": 0.0055
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9973,
        "Short-Term Debt": 0.0027
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9981,
        "Short-Term Debt": 0.0019
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9985,
        "Short-Term Debt": 0.0015
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9993,
        "Short-Term Debt": 0.0007
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9654,
        "Short-Term Debt": 0.0346
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9559,
        "Short-Term Debt": 0.0441
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9382,
        "Short-Term Debt": 0.0618
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9718,
        "Short-Term Debt": 0.0282
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9792,
        "Short-Term Debt": 0.0208
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9765,
        "Short-Term Debt": 0.0235
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.6092,
        "Short-Term Debt": 0.3908
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.4072,
        "Short-Term Debt": 0.5928
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.4822,
        "Short-Term Debt": 0.5178
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.5578,
        "Short-Term Debt": 0.4422
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.7504,
        "Short-Term Debt": 0.2496
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.6513,
        "Short-Term Debt": 0.3487
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.8885,
        "Short-Term Debt": 0.1115
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9308,
        "Short-Term Debt": 0.0692
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9687,
        "Short-Term Debt": 0.0313
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9757,
        "Short-Term Debt": 0.0243
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9783,
        "Short-Term Debt": 0.0217
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9827,
        "Short-Term Debt": 0.0173
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9813,
        "Short-Term Debt": 0.0187
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9827,
        "Short-Term Debt": 0.0173
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9845,
        "Short-Term Debt": 0.0155
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9865,
        "Short-Term Debt": 0.0135
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9861,
        "Short-Term Debt": 0.0139
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9874,
        "Short-Term Debt": 0.0126
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9824,
        "Short-Term Debt": 0.0176
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9978,
        "Short-Term Debt": 0.0022
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9974,
        "Short-Term Debt": 0.0026
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9954,
        "Short-Term Debt": 0.0046
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9939,
        "Short-Term Debt": 0.0061
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9975,
        "Short-Term Debt": 0.0025
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.998,
        "Short-Term Debt": 0.002
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 5.3901e-06
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 1.1104e-06
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9993,
        "Short-Term Debt": 0.0007
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9998,
        "Short-Term Debt": 0.0002
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9899,
        "Short-Term Debt": 0.0101
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9958,
        "Short-Term Debt": 0.0042
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9986,
        "Short-Term Debt": 0.0014
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9998,
        "Short-Term Debt": 0.0002
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9957,
        "Short-Term Debt": 0.0043
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9971,
        "Short-Term Debt": 0.0029
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9983,
        "Short-Term Debt": 0.0017
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9976,
        "Short-Term Debt": 0.0024
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9786,
        "Short-Term Debt": 0.0214
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9822,
        "Short-Term Debt": 0.0178
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9796,
        "Short-Term Debt": 0.0204
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.982,
        "Short-Term Debt": 0.018
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.98,
        "Short-Term Debt": 0.02
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9983,
        "Short-Term Debt": 0.0017
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9858,
        "Short-Term Debt": 0.0142
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9877,
        "Short-Term Debt": 0.0123
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9223,
        "Short-Term Debt": 0.0777
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9163,
        "Short-Term Debt": 0.0837
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9342,
        "Short-Term Debt": 0.0658
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9663,
        "Short-Term Debt": 0.0337
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9923,
        "Short-Term Debt": 0.0077
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9911,
        "Short-Term Debt": 0.0089
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9958,
        "Short-Term Debt": 0.0042
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9995,
        "Short-Term Debt": 0.0005
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9985,
        "Short-Term Debt": 0.0015
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9422,
        "Short-Term Debt": 0.0578
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9928,
        "Short-Term Debt": 0.0072
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9778,
        "Short-Term Debt": 0.0222
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9946,
        "Short-Term Debt": 0.0054
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.997,
        "Short-Term Debt": 0.003
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9931,
        "Short-Term Debt": 0.0069
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9935,
        "Short-Term Debt": 0.0065
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9928,
        "Short-Term Debt": 0.0072
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9603,
        "Short-Term Debt": 0.0397
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9566,
        "Short-Term Debt": 0.0434
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9557,
        "Short-Term Debt": 0.0443
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.951,
        "Short-Term Debt": 0.049
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.833,
        "Short-Term Debt": 0.167
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9644,
        "Short-Term Debt": 0.0356
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9661,
        "Short-Term Debt": 0.0339
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9584,
        "Short-Term Debt": 0.0416
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9576,
        "Short-Term Debt": 0.0424
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.92,
        "Short-Term Debt": 0.08
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9424,
        "Short-Term Debt": 0.0576
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9659,
        "Short-Term Debt": 0.0341
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9638,
        "Short-Term Debt": 0.0362
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.957,
        "Short-Term Debt": 0.043
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9658,
        "Short-Term Debt": 0.0342
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9692,
        "Short-Term Debt": 0.0308
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9812,
        "Short-Term Debt": 0.0188
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9845,
        "Short-Term Debt": 0.0155
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9868,
        "Short-Term Debt": 0.0132
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9657,
        "Short-Term Debt": 0.0343
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9382,
        "Short-Term Debt": 0.0618
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9303,
        "Short-Term Debt": 0.0697
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9441,
        "Short-Term Debt": 0.0559
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9549,
        "Short-Term Debt": 0.0451
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9738,
        "Short-Term Debt": 0.0262
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9788,
        "Short-Term Debt": 0.0212
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9858,
        "Short-Term Debt": 0.0142
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9597,
        "Short-Term Debt": 0.0403
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9429,
        "Short-Term Debt": 0.0571
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9256,
        "Short-Term Debt": 0.0744
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9581,
        "Short-Term Debt": 0.0419
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9875,
        "Short-Term Debt": 0.0125
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9978,
        "Short-Term Debt": 0.0022
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9986,
        "Short-Term Debt": 0.0014
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9987,
        "Short-Term Debt": 0.0013
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9979,
        "Short-Term Debt": 0.0021
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.996,
        "Short-Term Debt": 0.004
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.993,
        "Short-Term Debt": 0.007
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9979,
        "Short-Term Debt": 0.0021
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 3.3768e-06
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 3.0738e-06
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9996,
        "Short-Term Debt": 0.0004
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 8.3877e-06
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 2.4735e-06
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9991,
        "Short-Term Debt": 0.0009
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9763,
        "Short-Term Debt": 0.0237
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9995,
        "Short-Term Debt": 0.0005
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9999,
        "Short-Term Debt": 0.0001
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 9.7962e-06
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9388,
        "Short-Term Debt": 0.0612
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9995,
        "Short-Term Debt": 0.0005
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9994,
        "Short-Term Debt": 0.0006
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9994,
        "Short-Term Debt": 0.0006
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9383,
        "Short-Term Debt": 0.0617
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9392,
        "Short-Term Debt": 0.0608
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9732,
        "Short-Term Debt": 0.0268
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9768,
        "Short-Term Debt": 0.0232
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9834,
        "Short-Term Debt": 0.0166
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9964,
        "Short-Term Debt": 0.0036
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9874,
        "Short-Term Debt": 0.0126
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9903,
        "Short-Term Debt": 0.0097
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9898,
        "Short-Term Debt": 0.0102
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9879,
        "Short-Term Debt": 0.0121
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9839,
        "Short-Term Debt": 0.0161
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9972,
        "Short-Term Debt": 0.0028
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9962,
        "Short-Term Debt": 0.0038
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9951,
        "Short-Term Debt": 0.0049
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9947,
        "Short-Term Debt": 0.0053
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9889,
        "Short-Term Debt": 0.0111
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9932,
        "Short-Term Debt": 0.0068
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9966,
        "Short-Term Debt": 0.0034
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9922,
        "Short-Term Debt": 0.0078
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.8848,
        "Short-Term Debt": 0.1152
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.8659,
        "Short-Term Debt": 0.1341
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9171,
        "Short-Term Debt": 0.0829
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9367,
        "Short-Term Debt": 0.0633
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9503,
        "Short-Term Debt": 0.0497
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9581,
        "Short-Term Debt": 0.0419
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.939,
        "Short-Term Debt": 0.061
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9259,
        "Short-Term Debt": 0.0741
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9244,
        "Short-Term Debt": 0.0756
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9286,
        "Short-Term Debt": 0.0714
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9434,
        "Short-Term Debt": 0.0566
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9424,
        "Short-Term Debt": 0.0576
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9359,
        "Short-Term Debt": 0.0641
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9335,
        "Short-Term Debt": 0.0665
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9322,
        "Short-Term Debt": 0.0678
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9168,
        "Short-Term Debt": 0.0832
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9126,
        "Short-Term Debt": 0.0874
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9039,
        "Short-Term Debt": 0.0961
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.8931,
        "Short-Term Debt": 0.1069
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9351,
        "Short-Term Debt": 0.0649
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9619,
        "Short-Term Debt": 0.0381
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9669,
        "Short-Term Debt": 0.0331
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9831,
        "Short-Term Debt": 0.0169
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.973,
        "Short-Term Debt": 0.027
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9776,
        "Short-Term Debt": 0.0224
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9949,
        "Short-Term Debt": 0.0051
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9942,
        "Short-Term Debt": 0.0058
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9918,
        "Short-Term Debt": 0.0082
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9794,
        "Short-Term Debt": 0.0206
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9723,
        "Short-Term Debt": 0.0277
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9616,
        "Short-Term Debt": 0.0384
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9564,
        "Short-Term Debt": 0.0436
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.92,
        "Short-Term Debt": 0.08
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9469,
        "Short-Term Debt": 0.0531
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9574,
        "Short-Term Debt": 0.0426
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9744,
        "Short-Term Debt": 0.0256
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9748,
        "Short-Term Debt": 0.0252
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9764,
        "Short-Term Debt": 0.0236
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9811,
        "Short-Term Debt": 0.0189
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9526,
        "Short-Term Debt": 0.0474
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9729,
        "Short-Term Debt": 0.0271
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.991,
        "Short-Term Debt": 0.009
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9945,
        "Short-Term Debt": 0.0055
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9981,
        "Short-Term Debt": 0.0019
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.994,
        "Short-Term Debt": 0.006
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9972,
        "Short-Term Debt": 0.0028
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9912,
        "Short-Term Debt": 0.0088
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9933,
        "Short-Term Debt": 0.0067
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9991,
        "Short-Term Debt": 0.0009
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9968,
        "Short-Term Debt": 0.0032
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9967,
        "Short-Term Debt": 0.0033
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9458,
        "Short-Term Debt": 0.0542
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9993,
        "Short-Term Debt": 0.0007
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9971,
        "Short-Term Debt": 0.0029
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9906,
        "Short-Term Debt": 0.0094
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.9987,
        "Short-Term Debt": 0.0013
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9991,
        "Short-Term Debt": 0.0009
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9993,
        "Short-Term Debt": 0.0007
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9967,
        "Short-Term Debt": 0.0033
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9998,
        "Short-Term Debt": 0.0002
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9977,
        "Short-Term Debt": 0.0023
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.999,
        "Short-Term Debt": 0.001
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9982,
        "Short-Term Debt": 0.0018
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9985,
        "Short-Term Debt": 0.0015
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9989,
        "Short-Term Debt": 0.0011
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9987,
        "Short-Term Debt": 0.0013
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9994,
        "Short-Term Debt": 0.0006
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9994,
        "Short-Term Debt": 0.0006
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9547,
        "Short-Term Debt": 0.0453
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9412,
        "Short-Term Debt": 0.0588
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9531,
        "Short-Term Debt": 0.0469
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.957,
        "Short-Term Debt": 0.043
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9549,
        "Short-Term Debt": 0.0451
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.9577,
        "Short-Term Debt": 0.0423
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9629,
        "Short-Term Debt": 0.0371
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.961,
        "Short-Term Debt": 0.039
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.959,
        "Short-Term Debt": 0.041
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9594,
        "Short-Term Debt": 0.0406
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9578,
        "Short-Term Debt": 0.0422
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9583,
        "Short-Term Debt": 0.0417
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9561,
        "Short-Term Debt": 0.0439
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9545,
        "Short-Term Debt": 0.0455
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.954,
        "Short-Term Debt": 0.046
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.953,
        "Short-Term Debt": 0.047
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9534,
        "Short-Term Debt": 0.0466
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9534,
        "Short-Term Debt": 0.0466
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9516,
        "Short-Term Debt": 0.0484
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.9773,
        "Short-Term Debt": 0.0227
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.9944,
        "Short-Term Debt": 0.0056
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.9802,
        "Short-Term Debt": 0.0198
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.982,
        "Short-Term Debt": 0.018
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.9888,
        "Short-Term Debt": 0.0112
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9856,
        "Short-Term Debt": 0.0144
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9845,
        "Short-Term Debt": 0.0155
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9837,
        "Short-Term Debt": 0.0163
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9878,
        "Short-Term Debt": 0.0122
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9904,
        "Short-Term Debt": 0.0096
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9889,
        "Short-Term Debt": 0.0111
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9963,
        "Short-Term Debt": 0.0037
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9813,
        "Short-Term Debt": 0.0187
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9906,
        "Short-Term Debt": 0.0094
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.97,
        "Short-Term Debt": 0.03
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.998,
        "Short-Term Debt": 0.002
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.9712,
        "Short-Term Debt": 0.0288
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.9976,
        "Short-Term Debt": 0.0024
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.9987,
        "Short-Term Debt": 0.0013
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9987,
        "Short-Term Debt": 0.0013
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9988,
        "Short-Term Debt": 0.0012
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9993,
        "Short-Term Debt": 0.0007
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9997,
        "Short-Term Debt": 0.0003
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9991,
        "Short-Term Debt": 0.0009
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9992,
        "Short-Term Debt": 0.0008
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9981,
        "Short-Term Debt": 0.0019
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9974,
        "Short-Term Debt": 0.0026
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 0.8664,
        "Short-Term Debt": 0.1336
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 0.8583,
        "Short-Term Debt": 0.1417
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 0.8764,
        "Short-Term Debt": 0.1236
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 0.8624,
        "Short-Term Debt": 0.1376
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 0.868,
        "Short-Term Debt": 0.132
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 0.8657,
        "Short-Term Debt": 0.1343
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 0.853,
        "Short-Term Debt": 0.147
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 0.8759,
        "Short-Term Debt": 0.1241
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 0.8911,
        "Short-Term Debt": 0.1089
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 0.8943,
        "Short-Term Debt": 0.1057
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 0.9087,
        "Short-Term Debt": 0.0913
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 0.9207,
        "Short-Term Debt": 0.0793
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 0.9255,
        "Short-Term Debt": 0.0745
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 0.9359,
        "Short-Term Debt": 0.0641
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 0.9385,
        "Short-Term Debt": 0.0615
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 0.9507,
        "Short-Term Debt": 0.0493
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 0.9618,
        "Short-Term Debt": 0.0382
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 0.9681,
        "Short-Term Debt": 0.0319
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 0.9721,
        "Short-Term Debt": 0.0279
    }],
    [{
        "year": "2002-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2003-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2004-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2005-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2006-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2007-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2008-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2009-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2010-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2011-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2012-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2013-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2014-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2015-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2016-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2017-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2018-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2019-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }, {
        "year": "2020-01-01",
        "Long-Term Debt": 1,
        "Short-Term Debt": 0
    }]
]